// extracted by mini-css-extract-plugin
module.exports = {"redlTextarea":"Textarea_redlTextarea__Ukgx9"};